import { render, staticRenderFns } from "./positions_form.vue?vue&type=template&id=b2e1bf5a&"
import script from "./positions_form.vue?vue&type=script&lang=js&"
export * from "./positions_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports